import { HIGHLIGHT_DELETE_INTENT_CLASS } from '@databases/highlights/constants';

import { createEffect } from '../utils/create-effect';

const APP_CONTAINER_ID = 'app';

/**
 * Reflects delete-preview intent on the application container so selection
 * highlights can switch to destructive styling. Disposal always removes the
 * class to avoid leaking preview state across recyclable machine instances.
 */
export const createDeleteIntentHighlightEffect = createEffect(() => ({
  deltaTypes: ['previewSelectionAction'],

  dispose() {
    document
      .getElementById(APP_CONTAINER_ID)
      ?.classList.remove(HIGHLIGHT_DELETE_INTENT_CLASS);
  },

  onDelta(delta) {
    const container = document.getElementById(APP_CONTAINER_ID);

    if (!container) {
      return;
    }

    if (delta.intent === 'delete') {
      container.classList.add(HIGHLIGHT_DELETE_INTENT_CLASS);
    } else {
      container.classList.remove(HIGHLIGHT_DELETE_INTENT_CLASS);
    }
  }
}));
